import React from 'react';

const SupportRequestsScreen = () => {
	return <div>SupportRequestsScreen</div>;
};

export default SupportRequestsScreen;
